module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/xbox.50f103fb.svg";